<crm-activity-logger
  *ngIf="mode === 'add'"
  [objectType]="crmObjectType"
  [crmObjectId]="companyId$ | async"
  [crmActivityId]="''"
  [extraAssociations]="extraAssociations$ | async"
  [hideAssociations]="true"
  layout="mobile"
  [expandAndSelectType]="''"
  (cancel)="setMode('view')"
  (activityCreated)="addActivity($event)"
></crm-activity-logger>

<div [hidden]="!(mode !== 'add')">
  <div #scrollableContainerRef class="activities-wrapper">
    <!-- Actions -->
    <button type="button" mat-stroked-button color="primary" (click)="setMode('add')">
      <mat-icon>add</mat-icon>
      {{ 'FRONTEND.SALES_UI.SALES_OPPORTUNITIES.LOG_ACTIVITY' | translate }}
    </button>

    <crm-timeline
      #crmTimelineRef
      [objectType]="crmAssociationType"
      [crmObjectId]="opportunityId$ | async"
      (activitiesChanged)="handleActivitiesChanged($event)"
    ></crm-timeline>
    <!-- this must be predicated on the first load already being done so more items will load if the page does not initially overflow -->
    <glxy-infinite-scroll-trigger
      *ngIf="showLoadMore"
      [visiblilityMargin]="60"
      (isVisible)="loadMoreActivities()"
    ></glxy-infinite-scroll-trigger>
  </div>
</div>
